/**
 * "Nova versão disponível · Atualizar", rendered in the app tree (T46).
 *
 * Mounted by `app/shell.tsx` inside the one `ToastProvider` and OUTSIDE the
 * session gate, so the prompt also reaches a person sitting on sign-in.
 *
 * It imports only `update-signal.ts`, `ui/overlay` and the two messages: the
 * prompt itself (`update-prompt.tsx`, which pulls the workout store) stays in
 * its own lazy chunk, loaded by `register.ts` only when a worker is waiting.
 * On the device nothing ever raises the signal and this draws nothing.
 */
import {
  "update.apply" as applyLabel,
  "update.available" as availableLabel,
} from "@repo/i18n";
import { useEffect, useSyncExternalStore } from "react";
import { useToast } from "../../ui/overlay";
import { get, subscribe, type UpdateSignal } from "./update-signal";

export function UpdatePromptHost(): null {
  const signal: UpdateSignal = useSyncExternalStore(subscribe, get, get);
  const { notify, dismiss } = useToast();

  useEffect(() => {
    if (signal.apply === null) {
      // `key === 0` is the initial snapshot: nothing has ever been raised.
      if (signal.key > 0) {
        dismiss();
      }
      return;
    }
    notify({
      action: { label: applyLabel(), onAction: signal.apply },
      message: availableLabel(),
      // Not a success: nothing has happened yet, and a check says it has.
      tone: "info",
    });
  }, [signal, notify, dismiss]);

  return null;
}
